import { RouterType } from '@online-webinar/router';
import { WebinarInsights } from '@online-webinar/webinar-management';
import { authGuard } from '../integrations/auth-guard';

export const updateRoute = (router: RouterType) => {
    router.routesById['/$webinarId/insights'].update({
        staticData: { title: { page: 'OptionMenu.Insights', forWebinar: true } },
        component: authGuard(WebinarInsights, { canBroadcast: true })
    });
};
